import { API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function createMemo(consultId, body) {
  return {
    types: [
      ACTION_TYPES.MEMO_CREATE_REQUESTED,
      ACTION_TYPES.MEMO_CREATE_SUCCEED,
      ACTION_TYPES.MEMO_CREATE_FAILED,
    ],
    promise: client => client.post(`/consults/${consultId}/memorandums`, body),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function getMemos(conversationId, params, isLoadMore) {
  return {
    types: [
      ACTION_TYPES.MEMOS_GET_REQUESTED,
      ACTION_TYPES.MEMOS_GET_SUCCEED,
      ACTION_TYPES.MEMOS_GET_FAILED,
    ],
    promise: client => client.get(`/conversations/${conversationId}/memorandums`, { params }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      isLoadMore,
    },
  };
}

export function getMemo(id) {
  return {
    types: [
      ACTION_TYPES.MEMO_GET_REQUESTED,
      ACTION_TYPES.MEMO_GET_SUCCEED,
      ACTION_TYPES.MEMO_GET_FAILED,
    ],
    promise: client => client.get(`/memorandums/${id}`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function updateMemoFee(doctorId, memoFee) {
  return {
    types: [
      ACTION_TYPES.MEMO_FEE_UPDATE_REQUESTED,
      ACTION_TYPES.MEMO_FEE_UPDATE_SUCCEED,
      ACTION_TYPES.MEMO_FEE_UPDATE_FAILED,
    ],
    promise: client => client.post(`/doctors/${doctorId}/memo-fee`, { memoFee }),
    options: {
      clientName: API_CONSULT,
    },
  };
}
